import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetResultByDivisionV2Domain = (state) =>
  state.get("widgetResultByDivisionV2", initialState)

export const makeSelectIsLoadingDivisions = () =>
  createSelector(selectWidgetResultByDivisionV2Domain, (state) =>
    state.get("isLoadingDivisions")
  )

export const makeSelectDivisionsDrillDown = () =>
  createSelector(selectWidgetResultByDivisionV2Domain, (state) =>
    state.get("divisionsDrillDown")
  )

export const makeSelectDimensions = () =>
  createSelector(selectWidgetResultByDivisionV2Domain, (state) =>
    state.get("dimensions")
  )

export const makeSelectMetric = () =>
  createSelector(selectWidgetResultByDivisionV2Domain, (state) =>
    state.get("metric")
  )

const makeSelectWidgetResultByDivisionV2 = () =>
  createSelector(selectWidgetResultByDivisionV2Domain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDivisionV2
export { selectWidgetResultByDivisionV2Domain }
